export default {
  stepper: {
    description: 'Onboarding do restaurante',
    steps: {
      confirm_email: 'Confirmar endereço de email',
      add_store_details: 'Adicione os dados da sua loja',
      add_personal_details: 'Adicione as suas informações pessoais',
      add_bank_details: 'Adicione dados bancários para pagamentos',
      add_tax_details: 'O seu negócio está registado para IVA?',
      upload_business_doc: 'Documento comprovativo de empresa',
      upload_personal_doc: 'Documento de identificação',
      confirm_details: 'Receber pagamentos',
    },
  },
  toasts: {
    failed_to_skip_verification_step: 'Erro ao ignorar etapa de verificação. Tente novamente',
  },
};
